<template>
  <div class="flex flex-col gap-2">
    <div>
      <div
        v-if="despacho?.fecha_efectiva_arribo && !editArrivalDate"
        class="grid grid-cols-5 gap-4"
      >
        <div class="text-nowrap">
          <p>Fecha efectiva de arribo</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p>
            {{
              despacho?.fecha_efectiva_arribo
                ? moment(despacho.fecha_efectiva_arribo).format("MM-DD-YYYY")
                : "-"
            }}
          </p>
        </div>
        <div class="mx-auto">
          <button
            class="btn-principal"
            @click="
              () => {
                editArrivalDate = true;
                if (!arrivalDate) arrivalDate = new Date();
              }
            "
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Seleccionar fecha efectiva de arribo </label>
          <b-form-datepicker v-model="arrivalDate"></b-form-datepicker>
        </div>
        <div class="flex flex-row mt-auto gap-2">
          <button
            class="btn-principal"
            type="button"
            @click="() => $emit('update-arrival-date', arrivalDate)"
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="() => (editArrivalDate = false)"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div
        v-if="despacho?.tipo.agente_cargas && estados?.agente_cargas"
        class="grid grid-cols-5 gap-4"
      >
        <div>
          <p>Agente de Cargas</p>
        </div>
        <div class="text-right font-bold uppercase col-span-3">
          {{ despacho?.tipo?.agente_cargas?.nombre ?? "-" }}
        </div>
        <div class="mx-auto">
          <button
            class="btn-principal"
            @click="editar('administrativa', 'agente_cargas')"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Seleccionar un agente de carga </label>
          <select id="agente_cargas-select" v-model="agente_cargas_id" required>
            <option value="0" disabled>Selecciona un Agente de Carga</option>
            <option
              :key="index"
              v-for="(agente_cargas, index) in informacionGeneral.agente_cargas"
              :value="agente_cargas.id"
            >
              {{ agente_cargas.nombre }}
            </option>
          </select>
        </div>
        <div class="flex flex-row mt-auto gap-2">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('administrativa', 'agente_cargas', true, {
                agente_cargas_id: agente_cargas_id,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('administrativa', 'agente_cargas')"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div
        v-if="despacho?.tipo?.compania_naviera && estados?.compania_naviera"
        class="grid grid-cols-5 gap-4"
      >
        <div>
          <p>Compañia Naviera</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          {{ despacho?.tipo?.compania_naviera?.nombre ?? "-" }}
        </div>
        <div class="mx-auto">
          <button
            class="btn-principal"
            @click="editar('administrativa', 'compania_naviera')"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Seleccionar Compañia Naviera </label>
          <select id="importancia-select" v-model="compania_naviera" required>
            <option value="0" disabled>Selecciona una Compañia Naviera</option>
            <option
              :key="index"
              v-for="(
                compania_naviera, index
              ) in informacionGeneral.companias_navieras"
              :value="compania_naviera.id"
            >
              {{ compania_naviera.nombre }}
            </option>
          </select>
        </div>
        <div class="flex flex-row mt-auto gap-2">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('administrativa', 'compania_naviera', true, {
                companias_navieras_id: compania_naviera,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('administrativa', 'compania_naviera')"
          >
            Cancelar
          </button>
        </div>
      </div>

      <div
        v-if="despacho?.tipo?.manifiesto && estados?.manifiesto"
        class="grid grid-cols-5 gap-4"
      >
        <div>
          <p>Manifiesto</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          {{ despacho?.tipo?.manifiesto?.nombre ?? "-" }}
        </div>
        <div class="mx-auto">
          <button
            @click="editar('administrativa', 'manifiesto')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Manifiesto </label>
          <select id="importancia-select" v-model="manifiesto" required>
            <option value="0" disabled>Selecciona un Manifiesto</option>
            <option
              :key="index"
              v-for="(extraportuario, index) in informacionGeneral.manifiesto"
              :value="extraportuario.id"
            >
              {{ extraportuario.nombre }}
            </option>
          </select>
        </div>
        <div class="flex flex-row mt-auto gap-2">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('administrativa', 'manifiesto', true, {
                manifiesto_id: manifiesto,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('administrativa', 'manifiesto')"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputRut from "../InputRut.vue";
import InputRegion from "../InputRegion.vue";
export default {
  components: { InputRut, InputRegion },
  name: "FormUsuario",

  props: {
    despacho: Object,
    postInformacionGeneral: Function,
    informacionGeneral: Object,

    editar: Function,

    estados: Object,
  },
  emits: ["update-arrival-date"],
  data() {
    return {
      manifiesto: "",
      compania_naviera: 0,
      agente_cargas_id: "",

      editArrivalDate: false,
      arrivalDate: undefined,
    };
  },
  mounted() {
    this.arrivalDate = this.despacho?.fecha_efectiva_arribo ? new Date(this.despacho.fecha_efectiva_arribo) : new Date();
    this.editArrivalDate = !this.despacho?.fecha_efectiva_arribo;
  },
  methods: {
    //
  },
};
</script>
